<div class="asa-dialog">
  <div>Change Control Selected: X</div>
  <label class="field">
    <span class="field__label">Description</span>
    <span class="field__hint">Description of change control</span>
    <textarea
      rows="2"
      [(ngModel)]="description"
      placeholder="Add a short description for Change Control"
    ></textarea>
  </label>

  <div>
    <div>Change Summary</div>
    <div *ngFor="let change of changes">
      <ng-container *ngTemplateOutlet="changeTemplate; context: {change: change}"></ng-container>
    </div>
    <ng-template #changeTemplate let-change="change" >
      <div>
        <strong>{{ change.changeTo }} {{ change.changeType}} </strong>
        {{ change.value }} ({{ change.type }})
      </div>
    </ng-template>
  </div>

  <!-- Group membership control start -->
  <div class="object-list" *ngIf="objects && objects.length">
    <ng-container *ngFor="let o of objects">
      <div class="object-row">
        <div class="object-row__main object-row__main-outline">
          <div class="object-row">
            <ng-container *ngTemplateOutlet="inputTemplate; context: { obj: { value: o.groupName, type: 'group'}}"></ng-container>
          </div>
          <div style="padding: 5px 0 0 0;">
            <div class="object-row__info" *ngFor="let member of o.memberGroups">
              <ng-container *ngTemplateOutlet="inputTemplate; context: { obj: member, list: o.memberGroups, typeHint: 'group' }"></ng-container>
            </div>
          </div>
          <div style="padding: 5px 0 0 0;">
            <div class="object-row__info" *ngFor="let member of o.memberObjects">
              <ng-container *ngTemplateOutlet="inputTemplate; context: { obj: member, list: o.memberObjects }"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-template #inputTemplate let-obj="obj" let-list="list" let-typeHint="typeHint">
    <input
      type="text"
      class="object-row__input"
      [(ngModel)]="obj.value"
      [class.object-row__input--invalid]="isInvalid(obj)"
      (ngModelChange)="onInputChange(obj, list, typeHint)"
      [placeholder]="obj.type === 'group' ? 'Group Name' : 'Object Value'"
    />
    <div class="object-row__meta">
      <span class="object-row__tag" [ngClass]="{'object-row__tag--group' : obj.type === 'group'}">
        {{ obj.type != '' ? obj.type : 'UNKNOWN' }}
      </span>
    </div>
  </ng-template>
  <!-- Group membership control end -->

  <div class="asa-dialog__error" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <div class="asa-dialog__footer">
    <button type="button" class="asa-button asa-button--solid" (click)="submit()">
      Save Changes
    </button>
  </div>
</div>